import { FieldInputProps } from "formik";

export const transformVanFieldProps = (
  props: FieldInputProps<unknown>
): FieldInputProps<unknown> => ({
  ...props,
  value: props.value ?? ""
});
